<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<!-- <breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" /> -->

		<main-content>
			<template #content>
				<div class="content columns column12">
					<div class="title-reverse-wrapper">
						<h1>{{ page.title || page.header }}</h1>
						<h2 v-if="page.subtitle" class="subtitle">{{ page.subtitle }}</h2>
					</div>
				</div>
				<div class="columns column12">
					<div class="columns column6">
						<p>
							<font-awesome-icon icon="fa-regular fa-location-dot" size="1x" />&nbsp;

							<strong>{{ defaults[locale].website.hotelName }}</strong>
							<br />
							<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span>
							<br />
							<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
							<br />
							<span>{{ defaults[locale].website.country }}</span>
							<br />
							<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
								<span>T: {{ defaults[locale].website.phone }}</span>
							</a>
							<br />
							<a :href="`mailto:${defaults[locale].website.email}`">
								<span>E: {{ defaults[locale].website.email }}</span>
							</a>
						</p>
					</div>
				</div>
			</template>
			<template #bgImage>
				<picture>
					<source srcset="/images/bg-index.webp" type="image/webp" />
					<source srcset="/images/bg-index.jpg" />
					<img class="fade-image" src="/images/bg-index.webp" alt="Booking benefits" loading="lazy" />
				</picture>
			</template>
		</main-content>

		<section class="main-content background-light">
			<div class="row flex contact-form-row">
				<div class="columns column6 contact-form-col">
					<h2>{{ $t('contactFormHeader') }}</h2>
					<contact-form name="contact" :form="form" />
				</div>
				<div class="columns column6 maps">
					<iframe
						id="maps"
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2436.266565185088!2d4.894913413150606!3d52.36558634753254!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c609957704f0bf%3A0x3b6f1a3f535425a6!2sCity%20Hotel%20Rembrandt%20Square!5e0!3m2!1sen!2snl!4v1752501709453!5m2!1sen!2snl"
						width="100%"
						height="450"
						style="border: 0"
						allowfullscreen=""
						loading="lazy"
					/>
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: form } = await useWebsiteFetch('contact', {
	query: { language: locale.value },
	key: `${locale.value}/contact`,
});
</script>

<style lang="scss" scoped>
.content {
	margin-top: var(space-xxl);
}

.contact-form-row {
	background: #fff;
}

.contact-form-col {
	background: #fff;
	padding: 50px;
}

.maps {
	background: #fff;
	padding: 20px;
}

#maps {
	min-height: 600px;
}

@media (max-width: 920px) {
	.contact-form-row {
		flex-flow: wrap;
	}

	.contact-form-col,
	.column6 {
		width: 100%;
	}
}
</style>
